<p-dialog
  [(visible)]="isVisible"
  [style]="{ width: '80vw' }"
  [maximizable]="true"
  [header]="'general.vehicle-locations' | translate"
  modal="true"
  (onHide)="closeMap()"
>
  <div class="row-container">
    <div class="vehicle-list" [class.hidden]="isFullscreen" *ngIf="type!=='case-timeline' && type!=='organization-timeline'">
      <div class="row">
        <div class="d-flex justify-content-start">
          <button class="btn btn-warning btn-sm" (click)="filterCollaps = !filterCollaps">
            {{ "general.filter" | translate }}
          </button>
        </div>
        <div *ngIf="filterCollaps">
          <div class="row mb-2 mt-3">
            <label for="vehicles" class="form-label">
              {{ "definition.vehicle.vehicle" | translate }}
            </label>

            <p-dropdown
              id="vehicles"
              [(ngModel)]="selectedVehicle"
              [options]="vehicleOptions"
              optionLabel="name"
              optionValue="value"
              [showClear]="true"
              [placeholder]="'general.select-please' | translate"
              appendTo="body"
              [filter]="true"
              (ngModelChange)="activeType==2?filter():null"
              [disabled]="selectedVehicle ? true: false"
            ></p-dropdown>

            <ng-container *ngIf="activeType==1">
              <label for="betweenTime" class="form-label mt-3">
                {{ "general.time-between" | translate }}
              </label>

              <p-dropdown
                id="betweenTime"
                [(ngModel)]="betweenTime"
                [options]="betweenTimes"
                [showClear]="true"
                [placeholder]="'general.select-please' | translate"
                appendTo="body"
                [filter]="true"
              ></p-dropdown>
            </ng-container>
          </div>
          <button class="btn btn-info mt-2 w-100" (click)="filter()" *ngIf="activeType==1">
            {{ "general.filtering" | translate }}
            <i class="fa fa-search ms-2"></i>
          </button>
        </div>
      </div>

      <nav>
        <ul>
          <li (click)="toggleType(1)" role="button"  tabindex="-1" [class.active]="activeType==1">{{ 'general.vehicle-locations' | translate }}</li>
          <li (click)="toggleType(2)" role="button"  tabindex="-1" [class.active]="activeType==2">{{ 'general.vehicle-live-locations' | translate }}
          </li>
        </ul>
      </nav>
    </div>
    <div
      class="map-container"
      *ngIf="isVisible"
      [class.fullscreen]="isFullscreen"
    >

      <div #mapContainer class="vehicle-location-map-leaflet"></div>
    </div>

  </div>

<app-loading [loading]="loading" [fullScreen]="true"></app-loading>

</p-dialog>
